
import { useField } from 'formik';
import { Grid } from '@material-ui/core';
import CodeNumberInput from './CodeNumberInput/CodeNumberInput';



interface CodeAccessFieldProperties {
    name: string;
}

const CodeAccessField: React.FC<CodeAccessFieldProperties> = (properties) => {
    const [field, meta, helpers] = useField(properties.name);

    const handleChange = (newValues: string[]) => {
        helpers.setValue(newValues);
    }


    return (
        <div style={{ margin: '1em 0' }}>

            <Grid container>
                <Grid item xs={3}>
                    <CodeNumberInput value={field.value[0]}
                        onChange={newValue => handleChange([newValue, ...field.value.slice(1)])} />
                </Grid>
                <Grid item xs={3}>
                    <CodeNumberInput value={field.value[1]}
                        onChange={newValue => handleChange([...field.value.slice(0, 1), newValue, ...field.value.slice(2)])} />
                </Grid>
                <Grid item xs={3}>
                    <CodeNumberInput value={field.value[2]}
                        onChange={newValue => handleChange([...field.value.slice(0, 2), newValue, ...field.value.slice(3)])} />
                </Grid>
                <Grid item xs={3}>
                    <CodeNumberInput value={field.value[3]}
                        onChange={newValue => handleChange([...field.value.slice(0, 3), newValue])} />
                </Grid>
            </Grid>
            {meta.error}


        </div>
    )
}

export default CodeAccessField;
